import { faStar, faTag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, TextWithIcon } from '@modusign/design-system';

interface IconLabelProps {
  name: string;
  bookmarked?: boolean;
}

export default function IconLabel({ name, bookmarked }: IconLabelProps) {
  return (
    <TextWithIcon
      ellipsis
      leftIcon={
        <Box
          as={FontAwesomeIcon}
          color={bookmarked ? 'iconPrimaryBase' : 'iconNeutralSlightlyDark'}
          fontSize="14px"
          icon={bookmarked ? faStar : faTag}
        />
      }
    >
      {name}
    </TextWithIcon>
  );
}
